import React from "react";

// Components
import SiteLink from "./site-link";
import SiteNavigation from "./site-navigation";

export default function SiteHeader(props) {
  const citiesLinks = props?.city?.navigationCities?.navigationSetItems
    ? props.city.navigationCities.navigationSetItems
    : [];
  const primaryLinks = props?.city?.navigationPrimary?.navigationSetItems
    ? props.city.navigationPrimary.navigationSetItems
    : [];
  const brands = props?.brands ? props.brands : [];
  const brandId = props.brandId ?? "0488daf6-d5d3-5796-941d-db9894bee626";

  return props.desktop ? (
    <>
      {props.showPrimaryNavigation && (
        <div id="main-nav" className="d-lg-none">
          <SiteNavigation navigation={primaryLinks} />
        </div>
      )}
      <div id="other-nav">
        {citiesLinks &&
          citiesLinks.map((link, i) => {
            return (
              <SiteLink
                key={`nav-tri-cities-link-${i}`}
                id={`other-nav-${i}`}
                link={link}
                i={i}
                isDropdown={false}
              />
            );
          })}
      </div>
    </>
  ) : brands ? (
    brands.map((link, i) => {
      const isBrandLinkActive = link.id === brandId;

      return (
        <SiteLink
          key={`nav-tri-cities-link-mobile-${i}`}
          id={(props?.id ? props.id : "") + `-mobile-nav-${i}`}
          link={link}
          i={i}
          isDropdown={false}
          isActive={isBrandLinkActive}
          showExternalIcon={false}
          includeTextToImage={false}
          accentColour={link.accentColour}
          brandLink={true}
        />
      );
    })
  ) : (
    citiesLinks &&
      citiesLinks.map((link, i) => {
        return (
          <SiteLink
            key={`nav-tri-cities-link-mobile-${i}`}
            id="mobile-nav"
            link={link}
            i={i}
            isDropdown={false}
          />
        );
      })
  );
}
